module.exports = __webpack_public_path__ + "clubhouse-logo.png";